/**
 * PRD-46 — `goals` and `preferred_context` moved from free-text strings to
 * catalog-driven arrays (matching `interests`, which was already a list).
 * Existing `StudentProfile.persona` rows written before the survey wizard
 * shipped still hold a plain string — `persona` is a JSONField with no DB
 * sub-schema, so there's no migration/backfill, just two shapes in flight.
 * Every reader normalizes through this so a legacy string renders as a
 * single-item list instead of needing its own branch. See PRD-46 §FR-5.
 */
export function personaListValue(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw.filter((x): x is string => typeof x === "string" && x.trim().length > 0)
  }
  if (typeof raw === "string" && raw.trim()) {
    return [raw.trim()]
  }
  return []
}
